export const TRANSLATION_SCOPE = 'settingsModule';
export const TRANSLATION_SETTINGS_SCOPE = [TRANSLATION_SCOPE, 'settings'];
